import axios from 'axios'
// import { Notify, Toast } from "vant";
// import store from '@/store'
//import baseURL from './baseURL'
const http = {}

var instance = axios.create({
  timeout: 500000
  // baseURL
})

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    if (config.h) {
      config.headers = config.h
    }
    // 请求头添加token
    // if (store.state.UserToken) {
    //   config.headers.token = store.state.UserToken

    // }
    config.headers.tenantId = 'e7b8bfd1db2c4d4f9e084ddd204b4272'
    // config.headers.tenantId = '83fd9c857e3c4c828b031846358321c6'
    //config.headers.Authorization = 'cs'
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
// 响应拦截器即异常处理
instance.interceptors.response.use(
  response => {
    return response.data
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          break
        case 401:
          // Message.warning({
          //   message: '授权失败，请重新登录'
          // })
          //store.commit('LOGIN_OUT')
          // setTimeout(() => {
          //     window.location.reload()
          // }, 1000)
          err.message = '授权失败'
          return
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = '请求错误,未找到该资源'
          break
        case 500:
          err.message = '服务器端出错'
          break
      }
    } else {
      err.message = '连接服务器失败'
    }
    // Notify({ type: "danger", message: err.response });
    return Promise.reject(err.response)
  }
)

http.get = function (url, options) {
  // var toast = Toast.loading({
  //   message: "请求中...",
  //   forbidClick: true,
  //   duration: 0
  // });
  return new Promise((resolve, reject) => {
    instance
      .get(url, options)
      .then(response => {
        // toast.clear()
        // if (response.openid) {
        //   resolve(response.openid)
        // }
        if (response == '访问过于频繁') {
          // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
        } else if (response.code === 1031) {
          // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
        } else if (response.code === 200) {
          resolve(response.data)
        } else {
          // Message.error({
          //   message: response.message
          // })\
          //Notify({ type: "danger", message: response.message });
          if (response.message == '没有权限！') {
            // Notify({ type: "danger", message: '请重新登录，没有权限！' });
          }
          resolve(response)
        }
      })
      .catch(e => {
        // toast.clear()
        // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
        console.log(e)
        reject('访问过于频繁，请稍后再试！')
      })
  })
}

http.post = function (url, data, options) {
  // var toast = Toast.loading({
  //   message: "请求中...",
  //   forbidClick: true,
  //   duration: 0
  // });
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, options)
      .then(response => {
        // toast.clear()
        if (response == '访问过于频繁') {
          // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
        } else if (response.code === 1031) {
          // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
          // } else if (response.code === 0) {
        } else if (response.code === 200) {
          resolve(response.data)
        } else {
          // Message.error({
          //   message: response.message
          // })
          //Notify({ type: "danger", message: response.message });
          if (response.message == '没有权限！') {
            // Notify({ type: "danger", message: '请重新登录，没有权限！' });
          }
          reject(response.message)
        }
      })
      .catch(e => {
        // toast.clear()
        // Notify({ type: "danger", message: '访问过于频繁，请稍后再试！' });
        console.log(e)
        reject('访问过于频繁，请稍后再试！')
      })
  })
}

export default http
